import Input from './src/input.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';
export const ToInput: SFCWithInstall<typeof Input> = withInstall(Input);
export * from './src/instance';
